(() => {
  const storageKey = 'category-products-wishlist';
  let wishlist;

  try {
    wishlist = new Set(JSON.parse(localStorage.getItem(storageKey) || '[]'));
  } catch (error) {
    wishlist = new Set();
  }

  const refreshWishlistUI = () => {
    document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
      const active = wishlist.has(button.dataset.productHandle);
      const productName = button.dataset.productTitle || button.dataset.productHandle;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', `${active ? 'Remove' : 'Add'} ${productName} ${active ? 'from' : 'to'} wishlist`);
    });

    document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
      count.textContent = wishlist.size;
      count.hidden = wishlist.size === 0;
    });
  };

  const saveWishlist = () => {
    try {
      localStorage.setItem(storageKey, JSON.stringify([...wishlist]));
    } catch (error) {
      // Keep the wishlist usable if browser storage is unavailable.
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-button]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.productHandle;
    if (wishlist.has(handle)) {
      wishlist.delete(handle);
    } else {
      wishlist.add(handle);
    }

    saveWishlist();
    refreshWishlistUI();
    document.dispatchEvent(new CustomEvent('wishlist:changed'));
  });

  window.addEventListener('storage', (event) => {
    if (event.key !== storageKey) return;
    try {
      wishlist = new Set(JSON.parse(event.newValue || '[]'));
      refreshWishlistUI();
    } catch (error) {
      // Ignore malformed values from another browser tab.
    }
  });

  document.addEventListener('shopify:section:load', refreshWishlistUI);
  window.refreshWishlistUI = refreshWishlistUI;
  refreshWishlistUI();
})();
